/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

import Complex128 from '@stdlib/complex-float64-ctor';
import constructorName from '@stdlib/utils-constructor-name';


// MAIN //

/**
* Tests if a value is a 128-bit complex number.
*
* @param {*} value - value to test
* @returns {boolean} boolean indicating if a value is a 128-bit complex number
*
* @example
* import Complex128 from '@stdlib/complex-float64-ctor';
*
* var x = new Complex128( 4.0, 2.0 );
*
* var bool = isComplex128( x );
* // returns true
*/
function isComplex128( value ) {
	return (
		value instanceof Complex128 ||
		constructorName( value ) === 'Complex128'
	);
}


// EXPORTS //

export default isComplex128;
